import React from 'react';
import ServicePage from '../components/services/ServicePage';
import pullUpBanners from '../data/services/pull-up-banners';

const PullUpBanners: React.FC = () => <ServicePage data={pullUpBanners} />;

export default PullUpBanners;
